import "whatwg-fetch";
import {
  getAPIConfig,
  convertQueryObjToString,
  handleAPIResponse,
  getFileManagerRoute,
} from "@utils/browser-helpers";
import { executeAPIRequest } from "@adapters/api";

export interface FileManagerAdapter {
  fetchFiles: (method: string, changes?: any) => Promise<any>;
  fetchScheduledFiles: (method?: string, changes?: any) => Promise<any>;
  fetchTrash: (method: string, changes?: any) => Promise<any>;
  postFolder: (method: string, changes?: any) => Promise<any>;
  fetchClients: (method: string, changes?: any) => Promise<any>;
  importFiles: (
    method: string,
    currentCTID?: string | number | null,
    sourceCTID?: string | number | null,
    changes?: any,
  ) => Promise<any>;
  fetchFileVersions: (
    method: string,
    keypathParam?: Record<string, any> | null,
    changes?: any,
  ) => Promise<any>;
}

declare global {
  interface Window {
    fileManagerAdapter: FileManagerAdapter;
  }
}

const fileManagerAdapter: FileManagerAdapter = {
  fetchFiles: async (method, changes = null) => {
    let path = "/live/files/";
    let route = getFileManagerRoute(path, true);
    const apiConfig = getAPIConfig(route, false, false, true);
    const response = await executeAPIRequest(apiConfig, method, {}, changes);
    const responseData = await response.json();
    return handleAPIResponse(responseData);
  },

  fetchScheduledFiles: async (method = "GET", changes = null) => {
    let path = "/schedule/files/";
    let route = getFileManagerRoute(path, true);
    const apiConfig = getAPIConfig(route, false, false, true);
    const response = await executeAPIRequest(apiConfig, method, {}, changes);
    const responseData = await response.json();
    return handleAPIResponse(responseData);
  },

  fetchTrash: async (method, changes = null) => {
    let path = "/live/trash/files/";
    let route = getFileManagerRoute(path, true);
    const apiConfig = getAPIConfig(route, false, false, true);
    const response = await executeAPIRequest(apiConfig, method, {}, changes);
    const responseData = await response.json();
    return handleAPIResponse(responseData);
  },

  postFolder: async (method, changes = null) => {
    let path = "/live/folder/";
    let route = getFileManagerRoute(path, true);
    const apiConfig = getAPIConfig(route, false, false, true);
    const response = await executeAPIRequest(apiConfig, method, {}, changes);
    const responseData = await response.json();
    return handleAPIResponse(responseData);
  },

  fetchClients: async (method, changes = null) => {
    let path = "/user_clients";
    let route = getFileManagerRoute(path, false);
    const apiConfig = getAPIConfig(route, false, false, true);
    const response = await executeAPIRequest(apiConfig, method, {}, changes);
    const responseData = await response.json();
    return handleAPIResponse(responseData);
  },

  importFiles: async (
    method,
    currentCTID = null,
    sourceCTID = null,
    changes = null,
  ) => {
    let path = `/import_files${
      currentCTID && sourceCTID ? `/${currentCTID}/${sourceCTID}` : ""
    }`;
    let route = getFileManagerRoute(path, false);
    const apiConfig = getAPIConfig(route, false, false, true);
    const response = await executeAPIRequest(apiConfig, method, {}, changes);
    const responseData = await response.json();
    return handleAPIResponse(responseData);
  },

  fetchFileVersions: async (method, keypathParam = {}, changes = null) => {
    let path = "/file_versions/";
    let key_path = keypathParam
      ? `/${convertQueryObjToString(keypathParam)}`
      : "";
    let route = getFileManagerRoute(path, true, key_path);
    const apiConfig = getAPIConfig(route, false, false, true);
    const response = await executeAPIRequest(apiConfig, method, {}, changes);
    const responseData = await response.json();
    return handleAPIResponse(responseData);
  },
};

window.fileManagerAdapter = fileManagerAdapter;

export default fileManagerAdapter;
